import {JsonRpcRequestWrapper} from '../json-rpc-request-wrapper';
import {HubApiTransformer} from '../protocol-transform/hub-api-transformer';
import {ClientApiErrorCodes} from './constants/client-api-error-codes';

export abstract class HubApiRequest<REQ, RESP>
    extends JsonRpcRequestWrapper<REQ, RESP> {
    // eslint-disable-next-line max-params
    protected constructor(
        url:string,
        method: string,
        deviceIdentifier: string|null,
        data: REQ,
        id: number|string|null
    ) {
        super(method, data, id);
        this.url = url;
        this.setTransformerAdapter(new HubApiTransformer<REQ, RESP>(deviceIdentifier));
    }

    protected errorShouldBeLoggedAsInfo(error: Error): boolean {
        return ('code' in error && error.code === ClientApiErrorCodes.ACCOUNT_TRANSFERRED);
    }
}
